import { useState } from "react";
import { Link } from "react-router-dom";
import { SERVICES } from "../lib/services";
import { QuoteModal } from "../components/QuoteModal";

export default function Services() {
  const [quoteService, setQuoteService] = useState(null);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 pb-24" data-testid="services-page">
      <div className="py-16">
        <div className="overline text-[var(--red)] mb-4">Services</div>
        <h1 className="font-display font-semibold text-4xl sm:text-5xl lg:text-6xl tracking-tight max-w-3xl leading-[1.05]">
          A full suite for credible <span className="text-[var(--red)]">public health evaluation.</span>
        </h1>
        <p className="mt-6 text-lg text-[var(--text-2)] max-w-2xl">
          Every engagement is scoped to your program's stage, your funder's requirements, and the decision you need to make.
          Pricing is quoted per scope — <Link to="/pricing" className="link-red">see typical ranges</Link>.
        </p>
      </div>

      <div className="grid lg:grid-cols-2 gap-px bg-[var(--border)] border border-[var(--border)]">
        {SERVICES.map((s) => (
          <div key={s.id} id={s.id} className="bg-[var(--bg)] p-10 flex flex-col" data-testid={`service-card-${s.id}`}>
            <s.icon className="w-8 h-8 text-[var(--red)] mb-6" />
            <h2 className="font-display text-2xl lg:text-3xl font-semibold tracking-tight mb-2">{s.title}</h2>
            <div className="text-xs text-[var(--silver)] uppercase tracking-wide mb-4">{s.subtitle}</div>
            <p className="text-[var(--text-2)] leading-relaxed mb-6">{s.desc}</p>
            <ul className="space-y-2 mb-8">
              {s.bullets.map((b) => (
                <li key={b} className="flex items-start gap-3 text-sm text-[var(--text-2)]">
                  <span className="w-1.5 h-1.5 bg-[var(--red)] mt-1.5" /> {b}
                </li>
              ))}
            </ul>
            <div className="mt-auto flex items-center justify-between gap-4 pt-2">
              <div className="font-display text-lg font-semibold text-white" data-testid={`service-range-${s.id}`}>
                {s.priceRange}
              </div>
              <button
                onClick={() => setQuoteService(s)}
                className="btn-red"
                data-testid={`request-quote-${s.id}`}
              >
                Request a Quote
              </button>
            </div>
          </div>
        ))}
      </div>

      <section className="mt-24 grid lg:grid-cols-2 gap-12 items-center">
        <img
          src="https://images.pexels.com/photos/4007745/pexels-photo-4007745.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt="Epidemiology"
          className="w-full max-h-[60vh] object-cover border border-[var(--border)]"
        />
        <div>
          <div className="overline text-[var(--silver)] mb-3">Not seeing what you need?</div>
          <h3 className="font-display text-3xl font-semibold tracking-tight mb-5">We scope custom engagements too.</h3>
          <p className="text-[var(--text-2)] leading-relaxed mb-7">
            From multi-site cohort studies to performance measurement system design, we build bespoke evaluations for complex programs.
          </p>
          <Link to="/contact" className="btn-red" data-testid="services-contact-btn">Request a Custom Scope</Link>
        </div>
      </section>

      {quoteService && <QuoteModal service={quoteService} onClose={() => setQuoteService(null)} />}
    </div>
  );
}
